//@ts-check
import React from 'react';
import { Grid, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
/** Custom style in order to ensure the same UI between single and multiline inputs */

var useStyles = makeStyles({
  root: {
    fontSize: '0.85rem',
    lineHeight: 'inherit',
    paddingTop: function paddingTop(props) {
      return props.labelPlacement !== 'top' ? 8 : 0;
    },
    fontFamily: 'inherit',
    '& div': {
      display: 'inline'
    }
  }
}, {
  name: 'ECFormField'
});

var FieldLabel = function FieldLabel(_ref) {
  var label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      required = _ref.required;
  var classes = useStyles({
    labelPlacement: labelPlacement
  });
  return label && React.createElement(Grid, {
    item: true,
    xs: labelPlacement === 'top' ? 12 : 4,
    container: true
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(InputLabel, {
    shrink: false,
    required: required,
    classes: classes,
    className: "label"
  }, React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: label
    }
  }))));
};

export default React.memo(FieldLabel);